import * as React from 'react';
import { makeContextModule } from '@cian/react-utils';

import { EMessageType } from '../../types/messageType';
import { TMessage, TOutcomingStatus } from '../../types/messages';

export interface IMessageContextValue {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
  chatId: string;
  messageType: EMessageType;
  isLastInChain: boolean;
  isFirstUserPhrase: boolean;
  messageRef: React.RefObject<HTMLDivElement | null>;
}

export const { Context: MessageContext, useContext: useMessageContext } = makeContextModule<IMessageContextValue>({
  contextName: 'MessageContext',
});
